"use client";

import { useContext, useEffect } from "react";
import Featured from "../Featured";
import ModuleContent from "./ModuleContent";
import ModuleRooms from "./ModuleRooms";
import { LanguageContext } from "@/context/languageContext";
import { MeetingsAndEventsOptionsQuery } from "@/types/wordpressQueries";
import Splash from "../Splash";
import { FeaturedComponent } from "@/types/modules";
import { MeetingsAndEventsRoom } from "@/types/wordpress";
import { useLanguageUrl } from "@/context/languageURLContext";

interface MeetingsAndEventsComponentProps {
  data: MeetingsAndEventsOptionsQuery;
  rooms: MeetingsAndEventsRoom[];
}

export default function MeetingsAndEventsComponent({
  data,
  rooms,
}: MeetingsAndEventsComponentProps) {
  const { language } = useContext(LanguageContext);
  const { setUrl } = useLanguageUrl(); // Access context values

  useEffect(() => {
    setUrl(`/${language === "en" ? "de" : "en"}/meetings-and-events`);
  }, [language, setUrl]);

  const featured: FeaturedComponent = {
    backgroundColor:
      language === "en"
        ? data.meetingsEventsOptions.featured.backgroundColor
        : data.meetingsEventsOptionsDE.featured.backgroundColor,
    title:
      language === "en"
        ? data.meetingsEventsOptions.featured.title
        : data.meetingsEventsOptionsDE.featured.title,
    custom:
      language === "en"
        ? data.meetingsEventsOptions.featured.custom
        : data.meetingsEventsOptionsDE.featured.custom,
  };

  return (
    <>
      {language === "en"
        ? data.meetingsEventsOptions.slider &&
          data.meetingsEventsOptions.slider.slider && (
            <Splash slider={data.meetingsEventsOptions.slider.slider} />
          )
        : data.meetingsEventsOptionsDE.slider &&
          data.meetingsEventsOptionsDE.slider.slider && (
            <Splash slider={data.meetingsEventsOptionsDE.slider.slider} />
          )}
      <ModuleContent
        title={
          language === "en"
            ? data.meetingsEventsOptions.meetingsAndEvents.contentTitle
            : data.meetingsEventsOptionsDE.meetingsAndEvents.contentTitle
        }
        links={
          language === "en"
            ? data.meetingsEventsOptions.meetingsAndEvents.contentLinks
            : data.meetingsEventsOptionsDE.meetingsAndEvents.contentLinks
        }
        body={
          language === "en"
            ? data.meetingsEventsOptions.meetingsAndEvents.contentText
            : data.meetingsEventsOptionsDE.meetingsAndEvents.contentText
        }
      />
      <ModuleRooms rooms={rooms} />
      <Featured featured={featured} />
    </>
  );
}
